import { render, staticRenderFns } from "./onebox-fileexpiredinbox.vue?vue&type=template&id=ce18ccfc&"
import script from "./onebox-fileexpiredinbox.vue?vue&type=script&lang=js&"
export * from "./onebox-fileexpiredinbox.vue?vue&type=script&lang=js&"
import style0 from "./onebox-fileexpiredinbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports